import { createFileRoute } from '@tanstack/react-router';

import { CreateExternalProcess } from '@/components/processes/CreateExternalProcess';
import { CreateProcess } from '@/components/processes/CreateProcess';
import { useProcessQuery } from '@/queries/useProcessQuery';

function ProcessRoute() {
  const { data: process } = useProcessQuery();

  if (!process) return null;

  return process.external ? <CreateExternalProcess /> : <CreateProcess />;
}

export const Route = createFileRoute('/_authenticated/_management/vorgaenge/$adminLevelId/$processId/edit')({
  component: ProcessRoute,
});
